import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cooling',
  templateUrl: './cooling.component.html',
  styleUrls: ['./cooling.component.scss']
})
export class CoolingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
